import { Box, useMediaQuery, useTheme } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import objectPath from "object-path";
import { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import QuickPanel from "../../app/partials/layout/QuickPanel";
import ScrollTop from "../../app/partials/layout/ScrollTop";
import AsideLeft from "./aside/AsideLeft";
import { ASIDE_COLLAPSED_WIDTH, ASIDE_WIDTH } from "./aside/layoutConstants";
import { menuConfig } from "./core";
import Footer from "./footer/Footer";
import Topbar from "./header/Topbar";
import HTMLClassService from "./HTMLClassService";
import KtContent from "./KtContent";
import LayoutConfig from "./LayoutConfig";
import LayoutInitializer from "./LayoutInitializer";

const htmlClassService = new HTMLClassService();

function Layout({
  children,
  asideDisplay,
  subheaderDisplay,
  selfLayout,
  layoutConfig,
}) {
  const theme = useTheme();
  const [asideOpen, setAsideOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  htmlClassService.setConfig(layoutConfig);

  // Scroll to top after location changes
  window.scrollTo(0, 0);

  const handleAsideToggle = isOpen => {
    setAsideOpen(isOpen);
  };

  return selfLayout !== "blank" ? (
    <LayoutInitializer
      styles={[{}]}
      menuConfig={menuConfig}
      layoutConfig={LayoutConfig}
      htmlClassService={htmlClassService}
    >
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: theme.palette.background.default,
        }}
      >
        {/* Header */}
        <Topbar
          open={asideOpen}
          onOpenMenu={() => handleAsideToggle(!asideOpen)}
        />
        {asideDisplay && (
          <AsideLeft
            open={asideOpen}
            onToggle={handleAsideToggle}
          />
        )}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            paddingTop: 8,
            overflow: "hidden",
            marginLeft: isMobile
              ? 0
              : asideOpen
              ? `${ASIDE_WIDTH}px`
              : `${ASIDE_COLLAPSED_WIDTH}px`,
            transition: theme.transitions.create("margin-left", {
              easing: theme.transitions.easing.sharp,
              duration: asideOpen
                ? theme.transitions.duration.enteringScreen
                : theme.transitions.duration.leavingScreen,
            }),
          }}
        >
          {/* Content */}
          <KtContent>{children}</KtContent>
        </Box>
        {/* Footer */}
        <Footer open={asideOpen} isMobile={isMobile} />
      </Box>
      <QuickPanel />
      <ScrollTop />
    </LayoutInitializer>
  ) : (
    // Blank Layout
    <div>
      <KtContent>{children}</KtContent>
    </div>
  );
}

const mapStateToProps = ({ i18n: { lang }, builder: { layoutConfig } }) => ({
  layoutConfig,
  lang,
  selfLayout: objectPath.get(layoutConfig, "self.layout"),
  asideDisplay: objectPath.get(layoutConfig, "aside.self.display"),
  subheaderDisplay: objectPath.get(layoutConfig, "subheader.display"),
});

export default withRouter(connect(mapStateToProps)(Layout));
